import { render, staticRenderFns } from "./proofDailog.vue?vue&type=template&id=16bb8fa9&scoped=true"
import script from "./proofDailog.vue?vue&type=script&lang=js"
export * from "./proofDailog.vue?vue&type=script&lang=js"
import style0 from "./proofDailog.vue?vue&type=style&index=0&id=16bb8fa9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bb8fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16bb8fa9')) {
      api.createRecord('16bb8fa9', component.options)
    } else {
      api.reload('16bb8fa9', component.options)
    }
    module.hot.accept("./proofDailog.vue?vue&type=template&id=16bb8fa9&scoped=true", function () {
      api.rerender('16bb8fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/proofDailog.vue"
export default component.exports